import { createSlice, createAction, createSelector } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  apiError: false,
  pfZipCode: 30005,
  plans: [],
  selectLines: [],
  selectedPackages: [],
  clickedLineId: null,
  clickedLineIdList: [],
  selectedDeviceDetails: [],
  noOfLines: 0,
  selectedPlan: null,
  isCustomerModalVisited: false,
  showNewCustomerModal: false,
  isShopPhoneDevice: false,
  isChangeDevice: false,
  isByodDevice: false,
  isHideContinue: false,
  isFwa:false,
  isLandingFromInternetWithMobile: false,
  htmlTemplateFcc:'',
  planDetailsFcc: {},
  taxesCharges : {},
  addressMicroUnit:{},
  addressMicroUnitPlanId:'',
  addressMicroUnitQuantity:'',
  plansFirstData: {},
  linesCount: 0,
  linesRemain: 0,
  selectedPlansFirstData: {},
  selectedFlexPlan: false,
  linesUpdated: false,
  addressFromLearn: {},
  linesUpdatedForByod: false,
};

const PlanFirstSlice = createSlice({
  name: "PlanFirst",
  initialState,
  reducers: {
    resetPlanFirstSlice: (state) => {
      return initialState;
    },
    setPageLoading: (state, action) => {
      state["loading"] = action.payload;
    },
    setAPIError: (state, action) => {
      state["apiError"] = action.payload;
    },
    setPfZipCode: (state, action) => {
      state["pfZipCode"] = action.payload;
    },
    setNoOfLines: (state, action) => {
      state["noOfLines"] = action.payload;
    },
    setSelectedPlan: (state, action) => {
      state["selectedPlan"] = action.payload;
    },
    setPlans: (state, action) => {
      state["plans"] = action.payload;
    },
    setSelectLines: (state, action) => {
      state["selectLines"] = action.payload;
    },
    setSelectedPackages: (state, action) => {
      state["selectedPackages"] = action.payload;
    },
    setClickedLineId: (state, action) => {
      state["clickedLineId"] = action.payload;
    },
    setClickedLineIdList: (state, action) => {
      state["clickedLineIdList"] = action.payload;
    },
    setSelectedDeviceDetails: (state, action) => {
      state["selectedDeviceDetails"] = action.payload;
    },
    setMetaInfo: (state, action) => {
      state["metaInformation"] = action.payload;
    },
    setShowNewCustomerModal: (state, action) => {
      state["showNewCustomerModal"] = action.payload;
    },
    setIsCustomerModalVisited: (state, action) => {
      state["isCustomerModalVisited"] = action.payload;
    },
    setIsShopPhoneDevice: (state, action) => {
      state["isShopPhoneDevice"] = action.payload;
    },
    setIsChangeDevice: (state, action) => {
      state["isChangeDevice"] = action.payload;
    },
    setIsByodDevice: (state, action) => {
      state["isByodDevice"] = action.payload;
    },
    setIsHideContinue: (state, action) => {
      state["isHideContinue"] = action.payload;
    },
    setIsFwa: (state, action) => {
      state["isFwa"] = action.payload;
    },
    setIsLandingFromInternetWithMobile: (state, action) => {
      state["isLandingFromInternetWithMobile"] = action.payload;
    },
    sethtmlTemplateFcc:(state, action) => {
      state["htmlTemplateFcc"] = action.payload;
    },
    setPlansDetailsFcc: (state, action) => {
      state["planDetailsFcc"] = action.payload;
    },
    setTaxesCharges: (state, action) => {
      state["taxesCharges"] = action.payload;
    },
    setAddressMicroUnit: (state, action) => {
      state["addressMicroUnit"] = action.payload;
    },
    setAddressMicroUnitPlanId: (state, action) => {
      state["addressMicroUnitPlanId"] = action.payload;
    },
    setAddressMicroUnitQuantity: (state, action) => {
      state["addressMicroUnitQuantity"] = action.payload;
    },
    setPlansFirstData: (state, action) => {
      state["plansFirstData"] = action.payload;
    },
    setLinesCount: (state, action) => {
      state["linesCount"] = action.payload;
    },
    setLinesRemain: (state, action) => {
      state["linesRemain"] = action.payload;
    },
    setSelectedPlansFirstData: (state,action)=>{
      state["selectedPlansFirstData"] = action.payload
    },
    setSelectedFlexPlan: (state,action)=>{
      state["selectedFlexPlan"] = action.payload
    },
    setLinesUpdated: (state,action)=>{
      state["linesUpdated"] = action.payload
    },
    setAddressFromLearn: (state,action) =>{
      state["addressFromLearn"] = action.payload
    },
    setLinesUpdatedForByod: (state,action)=>{
      state["linesUpdatedForByod"] = action.payload
    }    
  },
});

export const reducer = PlanFirstSlice.reducer;
export const getMetaInformation = createAction(
  "PlanFirstSlice/getMetaInformation"
);
export const getInitPageLoadInfo = createAction(
  "PlanFirstSlice/getInitPageLoadInfo"
);
export const getPlans = createAction("PlanFirstSlice/getPlans");
export const getTaxesCharges = createAction("PlanFirstSlice/getTaxesCharges");
export const selectLines = createAction("PlanFirstSlice/selectLines");
export const addDeviceToLines = createAction("PlanFirstSlice/addDeviceToLines");
export const removeLineFromLines = createAction(
  "PlanFirstSlice/removeLineFromLines"
);
export const addLineToLines = createAction("PlanFirstSlice/addLineToLines");
export const changePlanForLines = createAction(
  "PlanFirstSlice/changePlanForLines"
);
export const updateFCCTemplate = createAction("PlanFirstSlice/updateFCCTemplate");
export const updateFCCJson = createAction("PlanFirstSlice/updateFCCJson");
export const {
  resetPlanFirstSlice,
  setPageLoading,
  setAPIError,
  setPfZipCode,
  setNoOfLines,
  setMetaInfo,
  setPlans,
  setSelectLines,
  setSelectedPlan,
  setSelectedPackages,
  setClickedLineId,
  setClickedLineIdList,
  setSelectedDeviceDetails,
  setShowNewCustomerModal,
  setIsCustomerModalVisited,
  setIsShopPhoneDevice,
  setIsChangeDevice,
  setIsByodDevice,
  setIsHideContinue,
  setIsFwa,
  sethtmlTemplateFcc,
  setPlansDetailsFcc,
  setTaxesCharges,
  setAddressMicroUnit,
  setAddressMicroUnitPlanId,
  setAddressMicroUnitQuantity,
  setIsLandingFromInternetWithMobile,
  setPlansFirstData,
  setLinesRemain,
  setLinesCount,
  setSelectedPlansFirstData,
  setSelectedFlexPlan,
  setLinesUpdated,
  setAddressFromLearn,
  setLinesUpdatedForByod
} = PlanFirstSlice.actions;
